import React, { Component } from 'react'
import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'reactstrap';
import ActionButtons from './ActionButtons'
import AddressForm from '../../forms/AddressForm'
class AddressList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            showBillingAddress: false,
            selectedAddress: null
        }
    }
    toggle() {
        this.setState({
            showNewAddress: !this.state.showNewAddress
        })
    }
    actionUpdate(initialValues){
        this.setState({
            selectedAddress: initialValues
        })
        this.toggle()
    }
    actionFav(fav, id){
        this.props.actionFav({favorite: fav}, id)
    }
    render(){
        return(
            <div>
                <h4 className="text-secondary">Libreta de direcciones</h4>
                <hr />
                <ListGroup>
                    {this.props.user && this.props.user.addresses &&
                    this.props.user.addresses.map((address)=>{
                        return(
                            <ListGroupItem key={address.id}>
                                <ListGroupItemHeading>
                                    {address.address}
                                    <ActionButtons
                                        addressId={address.id}
                                        address={address}
                                        actionDelete={this.props.actionDelete}
                                        actionUpdate={this.actionUpdate.bind(this)}
                                        actionFav={this.actionFav.bind(this)}
                                    />
                                </ListGroupItemHeading>
                                <ListGroupItemText>
                                    {address.name}<br />
                                    {address.address}, {address.city}<br />
                                    {address.postal}, {address.region}
                                </ListGroupItemText>
                            </ListGroupItem>
                        )
                    })}
                </ListGroup>
                <AddressForm
                    toggler={this.toggle.bind(this)}
                    show={this.state.showNewAddress}
                    selectedAddress={this.state.selectedAddress}
                />
                <div className="form-actions">
                    <button
                        type="button"
                        className="btn btn-primary next float-right"
                        onClick={this.toggle.bind(this)}
                    >
                        Añadir nueva dirección &nbsp;
                        <i className="fa fa-check-circle-o"></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default AddressList


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/addresses/Addresses.jsx